import React from 'react'
import { flowRight } from 'lodash'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { withRouter } from 'react-router-dom'
import { writeNavHistoryEntry } from 'lib/utils/store/navHistory'

class Location extends React.Component {
    componentDidMount () {
        this.writeLocation()
    }

    componentDidUpdate (prevProps) {
        if (prevProps.location.key !== this.props.location.key) {
            this.writeLocation()
        }
    }

    writeLocation () {
        const { history, location, match } = this.props
        writeNavHistoryEntry(history, location, match)
    }

    render () {
        return null
    }
}

export default flowRight(
    withErrorBoundaryNoRender,
    withRouter,
)(Location)
